<div
  class="app-bar"
  [class.app-bar--with-safe-area]="hasSafeArea"
  [ngClass]="['app-bar--' + appearance]"
>
  <div class="app-bar__content">
    <button
      class="app-bar__button"
      *ngIf="hasBackButton"
      (click)="_onClickBackButton()"
    >
      <svg-icon
        class="app-bar__icon"
        src="./assets/icons/back.svg"
        alt="back"
      ></svg-icon>
    </button>
    <h2 class="app-bar__title">{{ title }}</h2>
    <ng-content select="[rightContent]"></ng-content>
    <button
      class="app-bar__button"
      *ngIf="hasCloseButton"
      (click)="_onClickCloseButton()"
    >
      <svg-icon class="app-bar__icon" src="./assets/icons/close.svg"></svg-icon>
    </button>
    <button
      class="app-bar__button"
      customButton
      *ngIf="hasSaveButton"
      (click)="_onClickSaveButton()"
      appearance="text"
      [isLoading]="isLoading"
      [disabled]="isLoading"
      [isSuccessful]="isSuccessful"
    >
      {{ "app_bar.save" | translate }}
    </button>
    <button
      class="app-bar__button"
      customButton
      *ngIf="hasPlusButton"
      (click)="_onClickPlusButton()"
      appearance="text"
    >
      <svg-icon class="app-bar__icon" src="./assets/icons/plus.svg"></svg-icon>
    </button>
    <button
      class="app-bar__button"
      customButton
      *ngIf="customButtonIconSvgPath"
      (click)="_onClickCustomButtonIcon()"
      appearance="text"
    >
      <svg-icon
        class="app-bar__icon"
        [src]="customButtonIconSvgPath"
      ></svg-icon>
    </button>
    <button
      customButton
      *ngIf="customButtonText"
      (click)="_onClickCustomButtonText()"
      appearance="flat"
      [isLoading]="isLoading"
      [disabled]="isLoading"
      [isSuccessful]="isSuccessful"
    >
      {{ customButtonText }}
    </button>
  </div>
</div>
